import { Button } from "@mui/material";

import { CustomButtonProps } from "interfaces/common";

const CustomButton = ({
    type,
    title,
    fullWidth,
    icon,
    handleClick,
    disabled,
}: CustomButtonProps) => {
    return (
        <Button
            disabled={disabled}
            type={type === "submit" ? "submit" : "button"}
            sx={{
                flex: fullWidth ? 1 : "unset",
                padding: "10px 15px",
                width: fullWidth ? "100%" : "fit-content",
                minWidth: 130,
                backgroundColor: "#1D78B2",
                color: "#fcfcfc",
                fontSize: 16,
                fontWeight: 600,
                gap: "10px",
                textTransform: "capitalize",
                "&:hover": {
                    opacity: 0.9,
                    bgcolor: "#2BD9C8"
                },
            }}
            onClick={handleClick}
        >
            {icon}
            {title}
        </Button>
    );
};

export default CustomButton;